import { formatNumber } from '../helpers/number-formatter';

const getFirstFrame = product => {
    const frames = product.frames;
    return frames ? frames[Object.keys(frames)[0]] : null;
};

const getFormattedPrice = (frame, type) => {
    if (!frame.prices) return undefined;
    return formatNumber(frame?.prices?.[type]?.centValue || 0);
};

export default product => {
    if (!product) return {};

    const firstFrame = getFirstFrame(product);

    return {
        item_id: product.productGroupSlug || product.slug || 'MISSING_ITEM_ID',
        item_name: product.name,
        item_brand: firstFrame?.brand || product.brand || 'BRAND',
        price: getFormattedPrice(firstFrame, 'sale') || formatNumber(product.price),
        affiliation: location.hostname,
        discount: getFormattedPrice(firstFrame, 'discount') || formatNumber(product.price),
        quantity: 1,
    };
};
